import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Download, ShoppingBag, Gift } from "lucide-react";

export default function Loja() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-green-50 to-green-100 py-12 sm:py-16 lg:py-20">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="text-center mb-8 sm:mb-12">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold font-primary text-gray-800 mb-4 sm:mb-6">
              Loja de Produtos
            </h1>
            <p className="text-base sm:text-lg lg:text-xl font-secondary text-gray-600 max-w-4xl mx-auto">
              Materiais gratuitos, e-books e produtos selecionados para sua jornada de saúde
            </p>
          </div>
        </div>
      </section>

      {/* E-book Gratuito em Destaque */}
      <section className="py-12 sm:py-16 bg-white">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="max-w-4xl mx-auto">
            <Card className="border-2 border-green-600 shadow-lg">
              <CardHeader className="text-center bg-green-50">
                <div className="flex justify-center mb-4">
                  <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center">
                    <Gift className="w-8 h-8 text-white" />
                  </div>
                </div>
                <CardTitle className="text-2xl sm:text-3xl font-bold font-primary text-gray-800">
                  E-book Gratuito
                </CardTitle>
                <CardDescription className="text-base sm:text-lg mt-2">
                  Guia completo sobre nutrição e bem-estar
                </CardDescription>
              </CardHeader>
              <CardContent className="pt-6">
                <div className="space-y-4">
                  <p className="text-gray-600 font-secondary text-center">
                    Baixe gratuitamente nosso e-book com dicas práticas e informações valiosas 
                    para transformar sua relação com a alimentação.
                  </p>
                  
                  <div className="bg-green-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-gray-800 mb-2">O que você vai aprender:</h3>
                    <ul className="space-y-2 text-gray-600">
                      <li className="flex items-start">
                        <span className="text-green-600 mr-2">✓</span>
                        <span>Fundamentos da nutrição equilibrada</span>
                      </li>
                      <li className="flex items-start">
                        <span className="text-green-600 mr-2">✓</span>
                        <span>Como criar hábitos alimentares sustentáveis</span>
                      </li>
                      <li className="flex items-start">
                        <span className="text-green-600 mr-2">✓</span>
                        <span>Dicas práticas para o dia a dia</span>
                      </li>
                      <li className="flex items-start">
                        <span className="text-green-600 mr-2">✓</span>
                        <span>Receitas saudáveis e deliciosas</span>
                      </li>
                    </ul>
                  </div>

                  <div className="flex justify-center pt-4">
                    <Button 
                      size="lg" 
                      className="bg-green-600 hover:bg-green-700 font-accent"
                    >
                      <Download className="w-5 h-5 mr-2" />
                      Baixar E-book Gratuito
                    </Button>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Seção de Produtos Futuros */}
      <section className="py-12 sm:py-16 bg-gray-50">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="text-center mb-8">
            <ShoppingBag className="w-12 h-12 text-green-600 mx-auto mb-4" />
            <h2 className="text-2xl sm:text-3xl font-bold font-primary text-gray-800 mb-4">
              Mais Produtos em Breve
            </h2>
            <p className="text-gray-600 font-secondary max-w-2xl mx-auto">
              Estamos preparando uma seleção especial de produtos e serviços para você. 
              Em breve, teremos cupons de desconto, indicações exclusivas e muito mais!
            </p>
          </div>

          {/* Placeholders para produtos futuros */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
            {[1, 2, 3].map((item) => (
              <Card key={item} className="opacity-50">
                <CardHeader>
                  <div className="w-full h-40 bg-gray-200 rounded-md mb-4 flex items-center justify-center">
                    <ShoppingBag className="w-12 h-12 text-gray-400" />
                  </div>
                  <CardTitle className="text-gray-500">Produto em Breve</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-gray-400 text-sm">
                    Aguarde novidades incríveis que estão por vir...
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
